const config = {
  baseUrl:
    process.env.NODE_ENV === "development" ? "http://localhost:8080" : "",
  storageUrl: "https://storage.googleapis.com/portfolio-274919.appspot.com",
};

export default config;
